'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PassRecoveryStepThree = undefined;

var _PassRecoveryStepThree2 = require('./PassRecoveryStepThree');

var _PassRecoveryStepThree3 = _interopRequireDefault(_PassRecoveryStepThree2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PassRecoveryStepThree = _PassRecoveryStepThree3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepThree/index.js
// module id = 1725
// module chunks = 0